import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NEW_QUERY_PATH } from "./nav-config";

export function isMacPlatform(): boolean {
  if (typeof navigator === "undefined") return false;
  return /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent);
}

function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
}

/**
 * Atalho global ⌘K (macOS) / Ctrl K (demais) para Nova consulta (S4, Cyber C7).
 * Só navega para a tela de consulta: não dispara busca nem consulta. Ignorado em campos de texto.
 */
export function useNewQueryShortcut(enabled: boolean): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) return undefined;
    const mac = isMacPlatform();

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.repeat || event.altKey || event.shiftKey || event.key.toLowerCase() !== "k") return;
      const modifier = mac ? event.metaKey && !event.ctrlKey : event.ctrlKey && !event.metaKey;
      if (!modifier) return;
      if (isEditableTarget(event.target) || isEditableTarget(document.activeElement)) return;
      event.preventDefault();
      navigate(NEW_QUERY_PATH);
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [enabled, navigate]);
}
